export default function forbiddenF12() {
  document.onkeydown =
    document.onkeyup =
    document.onkeypress =
      function () {
        if ((window.event as any).keyCode == 123) {
          window.event.returnValue = false;
          return false;
        }
      };
}
